import styled from "styled-components";

export const IdDiv = styled.div`
  color: ${({ theme }) => theme.colors.primaryBlue};
`;

export const Title = styled.h1`
  margin-top: 0;
`;

interface IDivRejected {
  statusReject?: string;
}
export const DivRejected = styled.div<IDivRejected>`
  ${(props) => {
    const status = props.statusReject;
    let color, backgroundColor;
    if (status === "rejected" || status === "expired") {
      color = "#FF6F61";
      backgroundColor = "rgba(255, 111, 97, 0.1)";
    } else if (status === "paid") {
      color = "#20CAA4";
      backgroundColor = "rgba(32, 202, 164, 0.1)";
    } else {
      color = "#2E353D";
      backgroundColor = "#ffeca3";
    }
    return `
    .status-reject {
      background-color: ${backgroundColor};
      color: ${color};
      width: 8.7rem;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      text-align: center;
    }`;
  }}
`;

export const ContentDiv = styled.div`
  align-items: center;
  display: grid;
  font-family: Montserrat;
  font-size: 1.3rem;
  grid-template-columns: 1fr 13rem 13rem;
  justify-content: space-between;
  margin-left: 1.1rem;
  margin-right: 1.1rem;

  .agent-aduana {
    width: 100%;
  }
`;
export const DivFlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;
export const StatusB = styled.b`
  margin: 0.6rem;
  font-size: 1.2rem;
`;
export const DivLine = styled.div`
  background: rgba(231, 231, 234, 0.74);
  height: 1px;
  margin-top: 1.6rem;
  width: 45.6rem;
`;
export const DivConsigneAgent = styled.div`
  color: rgba(8, 8, 43, 0.35);
  margin-top: 1.2rem;
`;
export const DivAgentName = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1.2rem;
`;

interface IDivAgent {
  isRuc?: any;
}
export const DivAgent = styled.div<IDivAgent>`
  color: #08082b;
  font-size: ${(props) => (props.isRuc ? "1.2rem" : "1.4rem")};
`;

export const DivNumVol = styled.div`
  color: #002e6c;
  font-size: 1.5rem;
  margin-top: 0.5rem;
`;

export const DivRucFact = styled.div`
  color: #2e353d;
  font-family: Montserrat;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 1rem;
`;
